/**
 * Assume mobile to have parsed 'validateMobile'
 */
export const last = (array: any[]) => array[array.length - 1];

export const nthNumber = (number: number) => {
  if (number > 3 && number < 21) return 'th';
  switch (number % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const pluralOrSingularText = (value: number, text: string) => {
  return value > 1 ? `${text}s` : text;
};

export const getInitials = (fullName: string): string => {
  if (!fullName || typeof fullName !== 'string') {
    return '';
  }

  const nameParts = fullName.trim().split(/\s+/);
  const initials = nameParts
    .filter((part) => part.length > 0)
    .map((part) => part[0].toUpperCase())
    .slice(0, 2)
    .join('');

  return initials;
};
